module.exports = __webpack_public_path__ + "static/media/es.1fcfc0dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/es.png
// module id = 1842
// module chunks = 0